import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CampaignSearchDropdownItemRow" }
const _hoisted_2 = { class: "CampaignSearchDropdownItemWrapper SearchDropdownItemTitle" }
const _hoisted_3 = { class: "CampaignSearchDropdownItem" }
const _hoisted_4 = { class: "CampaignSearchDropdownItemWrapper SearchDropdownItemSubtitle" }
const _hoisted_5 = { class: "CampaignSearchDropdownItem" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "CampaignSearchDropdownItemContainer",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.name), 1 /* TEXT */)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.id), 1 /* TEXT */)
      ])
    ])
  ]))
}